// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-editor_App__OmT7g {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 12; /* Поверх всех элементов */
}

.match-editor_WindowEditor__hO6Iu {
    position: relative;
    background-color: white;
    min-height: max-content;
    width: 800px;
    border-radius: 12px;
}

.match-editor_Close__ZLvcT {
    position: absolute;
    top: 0;
    right: -80px;

    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding: 5px 10px;

    height: max-content;
    width: max-content;
    border-radius: 20px;

    -webkit-user-select: none;

            user-select: none;
    cursor: pointer;
}

.match-editor_ControlBar__cunNg{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

.match-editor_Control__DjQ-3{
    padding: 15px;
    background-color: rgba(10, 30, 210, 0.8);
    color: #fff;
    margin-left: 10px;
    border-radius: 5px;
    cursor: pointer
}`, "",{"version":3,"sources":["webpack://./src/widgets/match-editor/ui/match-editor.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC,EAAE,0BAA0B;IAChE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW,EAAE,0BAA0B;AAC3C;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;;IAEjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;;IAEnB,yBAAiB;;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB;AACJ","sourcesContent":[".App {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 12; /* Поверх всех элементов */\n}\n\n.WindowEditor {\n    position: relative;\n    background-color: white;\n    min-height: max-content;\n    width: 800px;\n    border-radius: 12px;\n}\n\n.Close {\n    position: absolute;\n    top: 0;\n    right: -80px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: white;\n    padding: 5px 10px;\n\n    height: max-content;\n    width: max-content;\n    border-radius: 20px;\n\n    user-select: none;\n    cursor: pointer;\n}\n\n.ControlBar{\n    display: flex;\n    justify-content: center;\n    margin-bottom: 10px;\n}\n\n.Control{\n    padding: 15px;\n    background-color: rgba(10, 30, 210, 0.8);\n    color: #fff;\n    margin-left: 10px;\n    border-radius: 5px;\n    cursor: pointer\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `match-editor_App__OmT7g`,
	"WindowEditor": `match-editor_WindowEditor__hO6Iu`,
	"Close": `match-editor_Close__ZLvcT`,
	"ControlBar": `match-editor_ControlBar__cunNg`,
	"Control": `match-editor_Control__DjQ-3`
};
export default ___CSS_LOADER_EXPORT___;
